import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'immutable';
import _ from 'lodash';

import Search from '../../records/Search';
import PassengerRailcard from '../../records/PassengerRailcard';

import RailcardTypes from '../search/RailcardTypes';


function Railcard ({ search, onChange }) {
    const _updateRailcards = (railcard) => {
        let railcards = new List();

        if (railcard && railcard.get('code')) {
            railcards = railcards.push(
                new PassengerRailcard({
                    code: railcard.get('code'),
                    quantity: 1
                })
            );
        }

        onChange(railcards);
    };

    return (
        <section className="booking__section">
            { /*
                BUG-FIX: Smartcard endpoint was returning empty, so instead we just don't try
                to request the special list and just return the normal one - if an invalid one
                is chosen and sent, it would never get applied anyway (by request of Alistair).
            */ }
            <RailcardTypes
                smartcard={ false /* BUG-FIX */ }
                value={ search.getIn([ 'railcards', 0, 'code' ], '') }
                onChange={ _updateRailcards }
            />
        </section>
    );
}


Railcard.propTypes = {
    search: PropTypes.instanceOf(Search).isRequired,
    onChange: PropTypes.func
};

Railcard.defaultProps = {
    onChange: _.noop
};


export default Railcard;



// WEBPACK FOOTER //
// ./src/components/smartcard/Railcard.js